var map = {
	"./bg07b.png": 93294,
	"./br/PT/S1/bg07b.png": 73231,
	"./in/EN/S1/bg07b.png": 19313,
	"./ph/EN/S1/bg07b.png": 15656,
	"./vn/VI/S1/bg07b.png": 61225
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 50660;